import { FormSection } from '../ui/FormSection';

export interface WineDetailFieldsProps {
  appellation: string;
  onAppellationChange: (value: string) => void;
  subAppellation: string;
  onSubAppellationChange: (value: string) => void;
  descriptors: string;
  onDescriptorsChange: (value: string) => void;
  grapes: string;
  onGrapesChange: (value: string) => void;
  allergens: string;
  onAllergensChange: (value: string) => void;
  appellationNotes: string;
  onAppellationNotesChange: (value: string) => void;
  isSubmitting: boolean;
}

export const WineDetailFields = ({
  appellation,
  onAppellationChange,
  subAppellation,
  onSubAppellationChange,
  descriptors,
  onDescriptorsChange,
  grapes,
  onGrapesChange,
  allergens,
  onAllergensChange,
  appellationNotes,
  onAppellationNotesChange,
  isSubmitting,
}: WineDetailFieldsProps) => (
  <FormSection title="Wine Details">
    {/* Appellation */}
    <div>
      <label htmlFor="appellation" className="block text-sm font-medium text-gray-700 mb-1">
        Appellation
      </label>
      <input
        id="appellation"
        type="text"
        value={appellation}
        onChange={(e) => onAppellationChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., Napa Valley"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Sub-Appellation */}
    <div>
      <label htmlFor="subAppellation" className="block text-sm font-medium text-gray-700 mb-1">
        Sub-Appellation
      </label>
      <input
        id="subAppellation"
        type="text"
        value={subAppellation}
        onChange={(e) => onSubAppellationChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., Oakville"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Descriptors */}
    <div>
      <label htmlFor="descriptors" className="block text-sm font-medium text-gray-700 mb-1">
        Descriptors
      </label>
      <input
        id="descriptors"
        type="text"
        value={descriptors}
        onChange={(e) => onDescriptorsChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., blackberry, oak, vanilla (comma-separated)"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
      <p className="mt-1 text-xs text-gray-500">Separate descriptors with commas</p>
    </div>

    {/* Grapes */}
    <div>
      <label htmlFor="grapes" className="block text-sm font-medium text-gray-700 mb-1">
        Grapes
      </label>
      <input
        id="grapes"
        type="text"
        value={grapes}
        onChange={(e) => onGrapesChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., 85% Cabernet Sauvignon, 15% Merlot"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Allergens */}
    <div>
      <label htmlFor="allergens" className="block text-sm font-medium text-gray-700 mb-1">
        Allergens
      </label>
      <input
        id="allergens"
        type="text"
        value={allergens}
        onChange={(e) => onAllergensChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="e.g., Contains sulfites"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Appellation Notes */}
    <div>
      <label htmlFor="appellationNotes" className="block text-sm font-medium text-gray-700 mb-1">
        Appellation Notes
      </label>
      <textarea
        id="appellationNotes"
        value={appellationNotes}
        onChange={(e) => onAppellationNotesChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="Notes about the appellation..."
        rows={3}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>
  </FormSection>
);
